import { render, staticRenderFns } from "./PoiHoursTable.vue?vue&type=template&id=311a983a"
import script from "./PoiHoursTable.js?vue&type=script&lang=js&external"
export * from "./PoiHoursTable.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports